// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1Ade1","title":"ClientCherryInfo_title__19V-I","itemText":"ClientCherryInfo_itemText__3Urgt"};